import LanguagePack from "../../../../../shared/lib/html5-software-library/src/ranj/language/LanguagePack";
import Anchor from "../../../../../shared/lib/html5-software-library/src/ranj/layout/Anchor";
import TextFitter from "../../../../../shared/lib/html5-software-library/src/ranj/layout/TextFitter";
import GameEvent from "../../../../../shared/src/ranj/app/core/GameEvent";
import AbstractScreenMediator from "../../app/ui/AbstractScreenMediator"

export default class BaseEndScreenMediator extends AbstractScreenMediator {

    /**
     * @param {createjs.DisplayObject} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LanguagePack} languagePack 
     * @param {*} layoutManager 
     * @param {*} soundManager 
     * @param {*} gameAssets  
     */
    constructor(target, dispatcher, languagePack, layoutManager, soundManager, appModel) {
        super(target, dispatcher, languagePack, layoutManager, soundManager, appModel);
    }

    destroy() {
        super.destroy();

        // NB: make sure to delete expose of start button to avoid memory leaks
        delete window.actions?.clickEndButton;
    }

    initialize() {
        super.initialize();

        this.initializeTexts();

        this._contentPanel9Slice = this.createGenericVerticalSlice9Panel(this._target.textPanel);

        // NB: A very large max height is set to allow the text to support any height 
        // as the content is under a vertical layout and can adjust vertically.
        const largeMaxHeightToAllowTextWrapping = 1000;
        const titleTextFitter = new TextFitter(this._target.textPanel.titleTextfield, { maxFontSize: 144, minFontSize: 40, lineHeightStep: 0, fontStep: 2, maxHeight: largeMaxHeightToAllowTextWrapping });
        titleTextFitter.setText(this.titleText);
        this.applyText(this._target.textPanel.bodyTextfield, this.bodyText);

        this._button = this.createButton(this._target.textPanel.button, this._handleButtonClick.bind(this), this.buttonText);

        this.updateLayout();

        this._contentPanel9Slice.update();
        this.anchorObject(this._target.textPanel, Anchor.T);

        this._exposeEndButton();

        this._animateIn(this._target);
    }

    initializeTexts() {
        this.titleText = this.getText("end.title");
        this.bodyText = this.getText("end.body");
        this.buttonText = this.getText("end.button");
    }

    updateLayout() {
        // calculate layout of text
        this._target.textPanel.bodyTextfield.y = this._target.textPanel.titleTextfield.y + this._target.textPanel.titleTextfield.getMeasuredHeight() + 40;
        this._button.skin.y = this._target.textPanel.bodyTextfield.y + this._target.textPanel.bodyTextfield.getMeasuredHeight() + 100;
    }

    _handleButtonClick() {
        this._button.setEnabled(false);
        this.dispatch(GameEvent.EXIT);
    }

    // Used for integration testing by Equalture
    _exposeEndButton() {
        window.actions = window.actions || {};
        window.actions.clickEndButton = () => {
            return new Promise((resolve, reject) => {
                this._handleButtonClick();
                resolve();
            });
        }
    }

    _animateIn(target) {
        //animate elements in, if any
        let delay = ANIMATION_DELAY;
        for (let i = 0; i <= 30; i++) {
            const elem = target[`elem${i}`];
            if (!elem) {
                continue;
            }
            elem.visible = false;
            const scale = elem.scaleX;
            elem.scaleX = elem.scaleY = .01 * scale;
            createjs.Tween.get(elem)
                .wait(delay += ANIMATION_ELEMENT_INTERVAL)
                .set({ visible: true })
                .wait(1)
                .to({ scaleX: scale, scaleY: scale }, ANIMATE_POP_IN_DURATION, createjs.Ease.backOut)
                .call(() => {
                    elem.play();
                })
        }
    }
}

const ANIMATION_ELEMENT_INTERVAL = 250;
const ANIMATION_DELAY = 250;
const ANIMATE_POP_IN_DURATION = 500;